import React, {useEffect, useState} from 'react';
import {Link as RouterLink, useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import {makeStyles} from '@mui/styles';
import {AppBar, Box, Fab, Hidden, IconButton, Paper, Toolbar, Typography, useTheme} from '@mui/material';
import clsx from 'clsx';
import {styled} from '@mui/material/styles';
import {useDispatch} from 'react-redux';
import HomeIcon from '../../../../assets/svgs/HomeIcon';
import MyOrders from '../../../../assets/svgs/MyOrders';
import MyAssets from '../../../../assets/svgs/MyAssets';
import MyPayments from '../../../../assets/svgs/MyPayments';

import OrderDialog from '../PlaceOrderDialog';
import {colorIcon, setData} from '../../../../actions';

const useStyles = makeStyles(() => ({
    navBar: {
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'center',
        display: 'flex !important',
        maxHeight: '70px',
    }
}));

const StyledFab = styled(Fab)({
    position: 'absolute',
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
});

const Bottom = ({
                    onMobileClose,
                    openMobile,
                    play,
                    floatingActionIconSrc,
                    ...rest
                }) => {

    const navItems = [
        {
            label: 'Home',
            activeName: 'Home',
            to: '/dashboard',
            icon: HomeIcon,
        },
        {
            label: 'Orders',
            activeName: 'My Orders',
            to: '/myOrders',
            icon: MyOrders,
        },
        {
            label: 'Assets',
            activeName: 'My Assets',
            to: '/newasset',
            icon: () => <MyAssets />,
            style: {marginLeft: '50%'},
        },
        {
            label: 'Payments',
            activeName: 'My Payments',
            to: '/payments',
            icon: MyPayments,
        },
    ];

    const dispatch = useDispatch();
    const location = useLocation();
    const classes = useStyles();
    const theme = useTheme();

    const [open, setOpen] = useState(false);
    const [activeButton, setActiveButton] = useState(null);

    useEffect(() => {
        if (openMobile && onMobileClose) {
            onMobileClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const handleNavClick = (e, index, title) => {
        setActiveButton(index);
        dispatch(colorIcon(title));
        dispatch(setData({
            OpenDetails: false,
            isDatum: false,
            isDashboard: false,
            datumData: [],
        }));
    };

    const handleOpenDialog = () => setOpen(true);
    const handleCloseDialog = () => setOpen(false);

    return (
        <Hidden lgUp>
            <AppBar
                color="primary"
                sx={{ top: 'auto', bottom: 0, backgroundColor: '#ffffff' }}
                className={clsx(classes.root)}
                {...rest}
            >
                <div className={classes.navBar}>
                    <Toolbar>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            width="100%"
                            px={2}
                        >
                            {navItems.map((item, index) => (
                                <Box key={index} component="span" sx={{ px: 2 }}>
                                    <IconButton
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            color: activeButton === index ? 'black' : '',
                                            ...item.style
                                        }}
                                        component={RouterLink}
                                        to={item.to}
                                        onClickCapture={play}
                                        onClick={(e) => handleNavClick(e, index, item.activeName)}
                                    >
                                        {item.customRender ? (
                                            item.customRender()
                                        ) : (
                                            <item.icon
                                                style={{
                                                    width: theme.breakpoints.down('sm') ? '20px' : '24px',
                                                    height: theme.breakpoints.down('sm') ? '20px' : '24px',
                                                }}
                                            />
                                        )}
                                        <Typography
                                            variant="overline"
                                            color="#6B778C"
                                            sx={{
                                                fontSize: {
                                                    xs: '0.7rem',
                                                    sm: '0.75rem',
                                                    md: '0.85rem',
                                                },
                                                color: activeButton === index ? 'black' : ''
                                            }}
                                        >
                                            {item.label}
                                        </Typography>
                                    </IconButton>
                                </Box>
                            ))}

                            {/* Floating Action Button */}
                            <StyledFab color="secondary" aria-label="add">
                                <IconButton onClickCapture={play} onClick={handleOpenDialog}>
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            borderRadius: '100px',
                                            boxShadow: '0px 4px 34px rgb(74 154 159 / 40%)',
                                            background: 'rgba(74, 154, 159, 0.2)',
                                        }}
                                    >
                                        <img
                                            alt="FAB Icon"
                                            src={floatingActionIconSrc}
                                            style={{
                                                width: '65px',
                                                height: '65px',
                                                borderRadius: '100px',
                                            }}
                                        />
                                    </Paper>
                                </IconButton>
                            </StyledFab>
                        </Box>
                    </Toolbar>
                </div>
            </AppBar>
            <OrderDialog open={open} handleClose={handleCloseDialog} />
        </Hidden>
    );
};

Bottom.propTypes = {
    play: PropTypes.func,
    floatingActionIconSrc: PropTypes.string.isRequired,
};

export default Bottom;